import Vue from 'vue'
import Resource from 'vue-resource'

Vue.use(Resource, {})

Vue.url.options.root = 'https://data0.meteo-parapente.com'

export default () => {
  return {
    root: Vue.url.options.root
  }
}



// WEBPACK FOOTER //
// ./src/resources/http.js